/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerParentProjection } from './PartnerParentProjection';
import {
    PartnerParentProjectionFromJSON,
    PartnerParentProjectionFromJSONTyped,
    PartnerParentProjectionToJSON,
    PartnerParentProjectionToJSONTyped,
} from './PartnerParentProjection';
import type { UserProjection } from './UserProjection';
import {
    UserProjectionFromJSON,
    UserProjectionFromJSONTyped,
    UserProjectionToJSON,
    UserProjectionToJSONTyped,
} from './UserProjection';

/**
 * 
 * @export
 * @interface Partner
 */
export interface Partner {
    /**
     * 
     * @type {number}
     * @memberof Partner
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    siret: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    image1920: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    mobile: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    zip: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    contactAddress: string;
    /**
     * 
     * @type {number}
     * @memberof Partner
     */
    totalInvoiced: number;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    creditSafeValue: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    creditSafeRiskText: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    saleWarn: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    saleWarnMsg: string;
    /**
     * 
     * @type {PartnerParentProjection}
     * @memberof Partner
     */
    parentId?: PartnerParentProjection | null;
    /**
     * 
     * @type {number}
     * @memberof Partner
     */
    partnerLatitude: number;
    /**
     * 
     * @type {number}
     * @memberof Partner
     */
    partnerLongitude: number;
    /**
     * 
     * @type {UserProjection}
     * @memberof Partner
     */
    userId: UserProjection;
    /**
     * 
     * @type {boolean}
     * @memberof Partner
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    comment: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    currentStatus: string;
    /**
     * 
     * @type {boolean}
     * @memberof Partner
     */
    creditSafe: boolean;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    nafCode: string;
    /**
     * 
     * @type {number}
     * @memberof Partner
     */
    companyWorkforce: number;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    xCreditStatus: string;
    /**
     * 
     * @type {string}
     * @memberof Partner
     */
    xCa: string;
}

/**
 * Check if a given object implements the Partner interface.
 */
export function instanceOfPartner(value: object): value is Partner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('siret' in value) || value['siret'] === undefined) return false;
    if (!('image1920' in value) || value['image1920'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('mobile' in value) || value['mobile'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zip' in value) || value['zip'] === undefined) return false;
    if (!('contactAddress' in value) || value['contactAddress'] === undefined) return false;
    if (!('totalInvoiced' in value) || value['totalInvoiced'] === undefined) return false;
    if (!('creditSafeValue' in value) || value['creditSafeValue'] === undefined) return false;
    if (!('creditSafeRiskText' in value) || value['creditSafeRiskText'] === undefined) return false;
    if (!('saleWarn' in value) || value['saleWarn'] === undefined) return false;
    if (!('saleWarnMsg' in value) || value['saleWarnMsg'] === undefined) return false;
    if (!('partnerLatitude' in value) || value['partnerLatitude'] === undefined) return false;
    if (!('partnerLongitude' in value) || value['partnerLongitude'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('comment' in value) || value['comment'] === undefined) return false;
    if (!('currentStatus' in value) || value['currentStatus'] === undefined) return false;
    if (!('creditSafe' in value) || value['creditSafe'] === undefined) return false;
    if (!('nafCode' in value) || value['nafCode'] === undefined) return false;
    if (!('companyWorkforce' in value) || value['companyWorkforce'] === undefined) return false;
    if (!('xCreditStatus' in value) || value['xCreditStatus'] === undefined) return false;
    if (!('xCa' in value) || value['xCa'] === undefined) return false;
    return true;
}

export function PartnerFromJSON(json: any): Partner {
    return PartnerFromJSONTyped(json, false);
}

export function PartnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Partner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'siret': json['siret'],
        'image1920': json['image_1920'],
        'email': json['email'],
        'phone': json['phone'],
        'mobile': json['mobile'],
        'street': json['street'],
        'city': json['city'],
        'zip': json['zip'],
        'contactAddress': json['contact_address'],
        'totalInvoiced': json['total_invoiced'],
        'creditSafeValue': json['credit_safe_value'],
        'creditSafeRiskText': json['credit_safe_risk_text'],
        'saleWarn': json['sale_warn'],
        'saleWarnMsg': json['sale_warn_msg'],
        'parentId': json['parent_id'] == null ? undefined : PartnerParentProjectionFromJSON(json['parent_id']),
        'partnerLatitude': json['partner_latitude'],
        'partnerLongitude': json['partner_longitude'],
        'userId': UserProjectionFromJSON(json['user_id']),
        'active': json['active'],
        'type': json['type'],
        'comment': json['comment'],
        'currentStatus': json['current_status'],
        'creditSafe': json['credit_safe'],
        'nafCode': json['naf_code'],
        'companyWorkforce': json['company_workforce'],
        'xCreditStatus': json['x_credit_status'],
        'xCa': json['x_ca'],
    };
}

export function PartnerToJSON(json: any): Partner {
    return PartnerToJSONTyped(json, false);
}

export function PartnerToJSONTyped(value?: Partner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'siret': value['siret'],
        'image_1920': value['image1920'],
        'email': value['email'],
        'phone': value['phone'],
        'mobile': value['mobile'],
        'street': value['street'],
        'city': value['city'],
        'zip': value['zip'],
        'contact_address': value['contactAddress'],
        'total_invoiced': value['totalInvoiced'],
        'credit_safe_value': value['creditSafeValue'],
        'credit_safe_risk_text': value['creditSafeRiskText'],
        'sale_warn': value['saleWarn'],
        'sale_warn_msg': value['saleWarnMsg'],
        'parent_id': PartnerParentProjectionToJSON(value['parentId']),
        'partner_latitude': value['partnerLatitude'],
        'partner_longitude': value['partnerLongitude'],
        'user_id': UserProjectionToJSON(value['userId']),
        'active': value['active'],
        'type': value['type'],
        'comment': value['comment'],
        'current_status': value['currentStatus'],
        'credit_safe': value['creditSafe'],
        'naf_code': value['nafCode'],
        'company_workforce': value['companyWorkforce'],
        'x_credit_status': value['xCreditStatus'],
        'x_ca': value['xCa'],
    };
}

